import React from "react";
import TargetTypeNameField from "../TargetTypeNameField";

function LocationNameField({ location, setLocation }) {
    const onChange = (value) => setLocation({ ...location, name: value, base: false });

    return (
        <TargetTypeNameField
            value={location.name}
            onValueChange={onChange}
            label="Name"
        />
    );
}

export default LocationNameField;
